import { Card, CloseIcon, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../Translations';
import { ExperienceResource } from '../../../../CurrentCollectionStep/BuilderV2/Types';
import Popover from '../Popover';
import PopoverSkeleton from './PopoverSkeleton';
import { useFetchExperienceDetail } from '../../../Previewer/Ready/Details/DefaultSection/PopoverContent/useFetchExperienceDetail';

export interface Props {
  experienceResource: ExperienceResource;
}

function DisplayPopover({ experienceResource }: Props) {
  const state = useFetchExperienceDetail(experienceResource);
  switch (state.kind) {
    case 'waiting':
    case 'loading':
      return <PopoverSkeleton />;
    case 'errored':
      return (
        <Card className="w-64 items-center flex-row justify-around p-4 mx-auto">
          <CloseIcon color="red" />
          <Typography>
            <T kind="Something went wrong" />
          </Typography>
        </Card>
      );
    case 'ready':
      return (
        <Popover
          experienceResource={experienceResource}
          experienceDetailResource={state.resource}
        />
      );
  }
}

export default observer(DisplayPopover);
